import { format } from 'date-fns';
import { shiftTypeNames } from '@/constants/schedule.constants';
import { OMSShiftType } from '@/api/apis/resources/schedule/schedule.types';

type OMSShiftCellProps = {
  date: string | null;
  shiftType: OMSShiftType;
};

export const OMSShiftCell = ({ date, shiftType }: OMSShiftCellProps) => {
  if (!date) return null;

  const dateFormatted = format(date, 'MM/dd/yyyy HH:mm zzz');

  return (
    <div className="flex flex-col">
      <span>{shiftTypeNames[shiftType]}</span>
      <span>{dateFormatted}</span>
    </div>
  );
};
